export default __webpack_public_path__ + "fonts/Roboto-400-cyrillic9.woff2";